



import { Vue, Component } from 'vue-property-decorator';
import AdminIframe from '@/components/iframe/AdminIframe.vue';

@Component({
  components: { AdminIframe },
})
export default class SalesIframe extends Vue {
  private remoteSrc = '';

  private setRemoteSrc() {
    const query = this.$route.query;
    const queryObject = { ...query, serviceType: 'PRO' };
    const queryString = new URLSearchParams(queryObject).toString();

    const src = process.env.VUE_APP_ADMIN_REMOTE_URL + '/statistic/sales/' + (this.$route.params.type ?? 'period') + '?' + queryString;

    this.remoteSrc = src;
  }

  created() {
    this.setRemoteSrc();
  }
}
